import { render, staticRenderFns } from "./addFamous.vue?vue&type=template&id=bad51102&scoped=true&"
import script from "./addFamous.vue?vue&type=script&lang=js&"
export * from "./addFamous.vue?vue&type=script&lang=js&"
import style0 from "./addFamous.vue?vue&type=style&index=0&id=bad51102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad51102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad51102')) {
      api.createRecord('bad51102', component.options)
    } else {
      api.reload('bad51102', component.options)
    }
    module.hot.accept("./addFamous.vue?vue&type=template&id=bad51102&scoped=true&", function () {
      api.rerender('bad51102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/famousPerson/famousPersonMent/components/addFamous.vue"
export default component.exports